import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import CashRequests from "@/pages/CashRequests";
import NewRequest from "@/pages/NewRequest";
import RequestDetail from "@/pages/RequestDetail";
import Approvals from "@/pages/Approvals";
import Disbursement from "@/pages/Disbursement";
import Delegasi from "@/pages/Delegasi";
import AuditLog from "@/pages/AuditLog";
import VendorBills from "@/pages/VendorBills";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import VehiclePayables from "@/pages/VehiclePayables";
import Expenses from "@/pages/Expenses";
import Branches from "@/pages/Branches";
import Companies from "@/pages/Companies";
import AllExpenses from "@/pages/AllExpenses";
import Transactions from "@/pages/Transactions";
import TransactionList from "@/pages/TransactionList";
import TransactionDetail from "@/pages/TransactionDetail";
import Receivables from "@/pages/Receivables";
import Customers from "@/pages/Customers";
import AdminTransactions from "@/pages/AdminTransactions";
import CashDeposits from "@/pages/CashDeposits";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import VehicleCashHistoryPage from "@/pages/VehicleCashHistoryPage";
import TransferProofs from "@/pages/TransferProofs";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/requests" element={<Shell><CashRequests /></Shell>} />
            <Route path="/expenses" element={
              <ProtectedRoute roles={["pemohon", "tim_kendaraan"]}><AppLayout><Expenses /></AppLayout></ProtectedRoute>
            } />
            <Route path="/vehicle-cash-history" element={
              <ProtectedRoute roles={["direktur", "tim_keuangan", "it_admin"]}><AppLayout><VehicleCashHistoryPage /></AppLayout></ProtectedRoute>
            } />
            <Route path="/requests/new" element={
              <ProtectedRoute roles={["pemohon", "tim_kendaraan"]}><AppLayout><NewRequest /></AppLayout></ProtectedRoute>
            } />
            <Route path="/requests/:id" element={<Shell><RequestDetail /></Shell>} />
            <Route path="/approvals" element={
              <ProtectedRoute roles={["direktur", "approver"]}><AppLayout><Approvals /></AppLayout></ProtectedRoute>
            } />
            <Route path="/disbursement" element={
              <ProtectedRoute roles={["tim_keuangan", "direktur", "it_admin"]}><AppLayout><Disbursement /></AppLayout></ProtectedRoute>
            } />
            <Route path="/delegasi" element={
              <ProtectedRoute roles={["direktur"]}><AppLayout><Delegasi /></AppLayout></ProtectedRoute>
            } />
            <Route path="/audit" element={
              <ProtectedRoute roles={["it_admin"]}><AppLayout><AuditLog /></AppLayout></ProtectedRoute>
            } />
            <Route path="/vendor-bills" element={
              <ProtectedRoute roles={["staf_tagihan", "direktur", "tim_keuangan", "it_admin"]}><AppLayout><VendorBills /></AppLayout></ProtectedRoute>
            } />
            <Route path="/vehicles" element={
              <ProtectedRoute roles={["tim_kendaraan", "direktur", "it_admin"]}><AppLayout><Vehicles /></AppLayout></ProtectedRoute>
            } />
            <Route path="/vehicles/:id" element={
              <ProtectedRoute roles={["tim_kendaraan", "direktur", "it_admin"]}><AppLayout><VehicleDetail /></AppLayout></ProtectedRoute>
            } />
            <Route path="/vehicle-bills" element={
              <ProtectedRoute roles={["tim_kendaraan", "direktur", "tim_keuangan", "it_admin"]}><AppLayout><VehiclePayables /></AppLayout></ProtectedRoute>
            } />
            <Route path="/laporan" element={
              <ProtectedRoute roles={["direktur", "tim_keuangan", "it_admin", "approver", "tim_kendaraan"]}><AppLayout><Reports /></AppLayout></ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute roles={["it_admin"]}><AppLayout><Users /></AppLayout></ProtectedRoute>
            } />
            <Route path="/transactions" element={
              <ProtectedRoute roles={["pemohon"]} requireSales><AppLayout><Transactions /></AppLayout></ProtectedRoute>
            } />
            <Route path="/transaction-list" element={
              <ProtectedRoute roles={["pemohon"]} requireSales><AppLayout><TransactionList /></AppLayout></ProtectedRoute>
            } />
            <Route path="/transactions/:id" element={
              <ProtectedRoute roles={["pemohon"]} requireSales><AppLayout><TransactionDetail /></AppLayout></ProtectedRoute>
            } />
            <Route path="/transfer-proofs" element={
              <ProtectedRoute roles={["direktur", "tim_keuangan", "it_admin"]}><AppLayout><TransferProofs /></AppLayout></ProtectedRoute>
            } />
            <Route path="/transfer-proofs/:id" element={
              <ProtectedRoute roles={["direktur", "tim_keuangan", "it_admin"]}><AppLayout><TransactionDetail /></AppLayout></ProtectedRoute>
            } />
            <Route path="/admin/transactions" element={
              <ProtectedRoute roles={["it_admin"]}><AppLayout><AdminTransactions /></AppLayout></ProtectedRoute>
            } />
            <Route path="/customers" element={
              <ProtectedRoute roles={["pemohon"]} requireSales><AppLayout><Customers /></AppLayout></ProtectedRoute>
            } />
            <Route path="/receivables" element={
              <ProtectedRoute roles={["pemohon"]} requireSales><AppLayout><Receivables /></AppLayout></ProtectedRoute>
            } />
            <Route path="/cash-deposits" element={
              <ProtectedRoute roles={["pemohon", "direktur", "tim_keuangan", "it_admin"]} requireSales><AppLayout><CashDeposits /></AppLayout></ProtectedRoute>
            } />
            <Route path="/all-expenses" element={
              <ProtectedRoute roles={["it_admin"]}><AppLayout><AllExpenses /></AppLayout></ProtectedRoute>
            } />
            <Route path="/companies" element={
              <ProtectedRoute roles={["it_admin", "direktur", "staf_tagihan", "tim_keuangan"]}><AppLayout><Companies /></AppLayout></ProtectedRoute>
            } />
            <Route path="/branches" element={
              <ProtectedRoute roles={["it_admin"]}><AppLayout><Branches /></AppLayout></ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
